import { styled } from '@mui/material/styles';
import { router } from '~/router';
import IconButton from 'Components/Buttons/IconButton';
import { refreshSite } from 'ducks/loadSite';
import { collapseTree, toggleProblems } from 'ducks/ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import icons from 'utils/ui/icons';

const ToolbarContainer = styled('div')({
    lineHeight: '34px'
});

const Component = ({ siteId }) => {
    const devices = useSelector(state => state.devices.models);
    const dispatch = useDispatch();

    const actionProps = {
        collapseTree: () => dispatch(collapseTree()),
        refreshSite: id => dispatch(refreshSite(id)),
        toggleProblems: (siteId, devices) => dispatch(toggleProblems(siteId, devices))
    };

    const buttons = [
        { icon: icons.collapse, onClick: actionProps.collapseTree, tooltip: 'Collapse tree' },
        { icon: icons.warning, onClick: () => actionProps.toggleProblems(siteId, devices), tooltip: 'Open on problems' },
        { icon: icons.siteDetails, onClick: () => router.navigate(`/sites/${siteId}`), tooltip: 'Site details' },
        { icon: icons.refresh, onClick: () => actionProps.refreshSite(siteId), tooltip: 'Refresh info' }
    ];

    return (
        <ToolbarContainer>
            {buttons.map(button => (
                <IconButton key={button.icon} {...button}/>
            ))}
        </ToolbarContainer>
    );
};

export default Component;
